/**
 * Theme Context for STAGSTER
 * Defaults the app to the main theme.
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext({
  theme: 'main',
  isFSwipeTheme: false,
  setTheme: () => {}
});

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const location = useLocation();
  const [theme, setTheme] = useState('main');

  // V2 no longer uses route-based alternate theming.
  // Reset back to the main theme when navigation changes after any legacy override.
  useEffect(() => {
    if (theme !== 'main') {
      setTheme('main');
    }
  }, [location.pathname, theme]);

  // Apply theme class to document body
  useEffect(() => {
    document.body.classList.remove('main-theme');
    document.body.classList.add('main-theme');
    document.documentElement.className = 'main-theme';

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('main-theme');
      document.documentElement.className = '';
    };
  }, []);

  const value = {
    theme,
    isFSwipeTheme: false,
    setTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
